"use client";
import { jsx } from "react/jsx-runtime";
import { DropdownCheckboxItem } from "../../primitive-dropdown/dropdown-checkbox-item.js";
import { AsyncGenericDropdown } from "./async-generic-dropdown.js";
function AsyncCheckboxesDropdown({ options: checkboxes, multiline, ...props }) {
    const options = checkboxes.map((option)=>({
            value: option.value,
            label: option.label,
            element: (elementProps)=>/*#__PURE__*/ jsx(DropdownCheckboxItem, {
                    checkbox: option,
                    multiline: multiline,
                    ...elementProps
                })
        }));
    return /*#__PURE__*/ jsx(AsyncGenericDropdown, {
        ...props,
        multiline: multiline,
        options: options,
        allowDeselect: true,
        multiselect: true
    });
}
export { AsyncCheckboxesDropdown };
